import { useCallback } from 'react'
import { getHeaderHeight } from '../providers/header'

export const useScrollTo = () => {
	/**
	 * @description Manage a simple scroll to element.
	 * @param {object} ref - The ref of the component.
	 * @param {number=} offset - Offset to be added to the calculation. Pass a negative number to subtract.
	 * @param {object=} options - Additional options to pass to scrollTo method.
	 * @returns {void}
	 */
	const manageScroll = useCallback(({ ref, offset = 0, ...options }) => {
		if (ref?.current) {
			const offsetTop = ref?.current?.getBoundingClientRect().top + window.pageYOffset
			setTimeout(
				() =>
					window.scrollTo({
						left: 0,
						top: offsetTop - getHeaderHeight() + offset,
						behavior: 'smooth',
						...options,
					}),
				0
			)
		}
	}, [])

	return { manageScroll }
}
